// Axios and configuration
import Axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"

// Interfaces
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import type { I_ApprovalLeaseAction } from "../types"

// Utilities
import snackBar from "src/utilities/snackBar/SnackBar"

/**
 * Fetches lease approval actions assigned to a specific approver.
 *
 * @param approverUserId - The employee ID of the approver
 * @returns An array of lease approval actions, or an empty array on failure
 */
const GetLeaseApprovalActions = async (
	approverUserId: number
): Promise<I_ApprovalLeaseAction[]> => {
	try {
		const response = await Axios.get<I_BaseAPIResponse<I_ApprovalLeaseAction[]>>(
			`${process.env.REACT_APP_API_URL}/api/approval/lease/actions?approverUserId=${approverUserId}`,
			AxiosConfig.configValue("min")
		)

		if (response.data.HasError) {
			snackBar({
				type: "error",
				text: response.data.ErrorMessage,
				timeout: 4000,
			})
			return []
		}

		return response.data.Data
	} catch (error) {
		console.error("GetLeaseApprovalActions failed:", error)
		snackBar({
			type: "error",
			text: "Failed to get lease approval actions",
			timeout: 4000,
		})
		return []
	}
}

export default GetLeaseApprovalActions
